/* ============================================================
   TROTTER UV premium interactions
   Scroll reveal · parallax · count-up · sticky buy bar
   ============================================================ */
(function () {
  if (window.__TROTTER_UV__) return;
  window.__TROTTER_UV__ = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- scroll reveal + stagger ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll(".uv-reveal:not([data-seen])");
    if (!("IntersectionObserver" in window) || reduce) {
      els.forEach(function (el) { el.classList.add("is-visible"); el.setAttribute("data-seen", "1"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });

    els.forEach(function (el, i) {
      el.setAttribute("data-seen", "1");
      // stagger siblings that share a parent group
      var grp = el.getAttribute("data-stagger");
      if (grp) el.style.setProperty("--d", (parseInt(grp, 10) * 90) + "ms");
      io.observe(el);
    });
  }

  /* ---------- count-up numbers ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dec = (el.getAttribute("data-count").split(".")[1] || "").length;
    var dur = 1500, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.firstChild.nodeValue = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
      else el.firstChild.nodeValue = target.toFixed(dec);
    }
    requestAnimationFrame(step);
  }
  function initCounts(root) {
    var els = (root || document).querySelectorAll("[data-count]:not([data-counted])");
    if (!("IntersectionObserver" in window) || reduce) {
      els.forEach(function (el) { el.setAttribute("data-counted", "1"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          countUp(e.target);
          e.target.setAttribute("data-counted", "1");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- progress line (how it works) ---------- */
  function initProgress(root) {
    var lines = (root || document).querySelectorAll(".uv-steps:not([data-seen])");
    lines.forEach(function (steps) {
      steps.setAttribute("data-seen", "1");
      var line = steps.querySelector(".uv-steps__line");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (line) line.style.setProperty("--p", "1");
            steps.querySelectorAll(".uv-step").forEach(function (s) { s.classList.add("is-visible"); });
            io.disconnect();
          }
        });
      }, { threshold: 0.4 });
      io.observe(steps);
    });
  }

  /* ---------- hero parallax (pointer) ---------- */
  function initParallax(root) {
    if (reduce) return;
    var stages = (root || document).querySelectorAll(".uv-hero__stage:not([data-px])");
    stages.forEach(function (stage) {
      stage.setAttribute("data-px", "1");
      var product = stage.querySelector(".uv-hero__product");
      var halo = stage.querySelector(".uv-hero__halo");
      var b1 = stage.querySelector(".uv-hero__badge--1");
      var b2 = stage.querySelector(".uv-hero__badge--2");
      var hero = stage.closest(".uv-hero");
      (hero || stage).addEventListener("pointermove", function (ev) {
        var r = (hero || stage).getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        if (product) product.style.transform = "translate(" + x * 22 + "px," + y * 22 + "px) rotateX(" + -y * 4 + "deg) rotateY(" + x * 5 + "deg)";
        if (halo) halo.style.transform = "translate(" + x * 36 + "px," + y * 36 + "px)";
        if (b1) b1.style.transform = "translate(" + x * -30 + "px," + y * -30 + "px)";
        if (b2) b2.style.transform = "translate(" + x * 30 + "px," + y * 24 + "px)";
      });
      (hero || stage).addEventListener("pointerleave", function () {
        [product, halo, b1, b2].forEach(function (el) { if (el) el.style.transform = ""; });
      });
    });
  }

  /* ---------- card spotlight ---------- */
  function initSpotlight(root) {
    if (reduce) return;
    (root || document).querySelectorAll(".uv-card:not([data-sl])").forEach(function (card) {
      card.setAttribute("data-sl", "1");
      card.addEventListener("pointermove", function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
        card.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
      });
    });
  }

  /* ---------- sticky buy bar ---------- */
  function initSticky(root) {
    var bar = (root || document).querySelector(".uv-stickybar");
    if (!bar || bar.getAttribute("data-on")) return;
    bar.setAttribute("data-on", "1");
    var hero = document.querySelector(".uv-hero");
    var cta = document.querySelector(".uv-cta");
    function check() {
      var pastHero = hero ? hero.getBoundingClientRect().bottom < 80 : window.scrollY > 600;
      var inCta = cta ? cta.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle("is-on", pastHero && !inCta);
    }
    window.addEventListener("scroll", check, { passive: true });
    check();
  }

  /* ---------- product gallery + carousel ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll("[data-uv-gallery]:not([data-g])").forEach(function (g) {
      g.setAttribute("data-g", "1");
      var main = g.querySelector("[data-uv-main]");
      var thumbs = g.querySelectorAll("[data-uv-thumb]");
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          var src = t.getAttribute("data-src");
          if (main && src) main.setAttribute("src", src);
          thumbs.forEach(function (x) { x.classList.remove("is-active"); });
          t.classList.add("is-active");
        });
      });

      var strip = g.querySelector("[data-uv-strip]");
      var viewport = g.querySelector("[data-uv-viewport]");
      var prev = g.querySelector("[data-uv-prev]");
      var next = g.querySelector("[data-uv-next]");
      if (strip && viewport && prev && next) {
        var perPage = 4, gap = 10, page = 0;
        function pages() { return Math.max(1, Math.ceil(thumbs.length / perPage)); }
        function update() {
          var shift = page * (viewport.clientWidth + gap);
          strip.style.transform = "translateX(" + (-shift) + "px)";
          prev.disabled = page <= 0;
          next.disabled = page >= pages() - 1;
        }
        prev.addEventListener("click", function () { if (page > 0) { page--; update(); } });
        next.addEventListener("click", function () { if (page < pages() - 1) { page++; update(); } });
        window.addEventListener("resize", function () { page = 0; update(); });
        update();
      }
    });
  }

  /* ---------- quantity selector ---------- */
  function initQty(root) {
    (root || document).querySelectorAll("[data-uv-qty]:not([data-q])").forEach(function (q) {
      q.setAttribute("data-q", "1");
      var input = q.querySelector("[data-qty-input]");
      var minus = q.querySelector("[data-qty-minus]");
      var plus = q.querySelector("[data-qty-plus]");
      function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
      if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, val() - 1); });
      if (plus) plus.addEventListener("click", function () { input.value = val() + 1; });
    });
  }

  /* ---------- product sticky add-to-cart ---------- */
  function initPdpSticky(root) {
    var bar = (root || document).querySelector("[data-uv-pdp-sticky]");
    if (!bar || bar.getAttribute("data-on")) return;
    bar.setAttribute("data-on", "1");
    var form = document.getElementById("uv-product-form");
    var cta = form ? form.querySelector(".uv-buy__cta") : null;
    var addBtn = bar.querySelector("[data-uv-sticky-add]");
    if (addBtn && form) {
      addBtn.addEventListener("click", function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
    function check() {
      if (!cta) return;
      var r = cta.getBoundingClientRect();
      var past = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle("is-on", past);
    }
    window.addEventListener("scroll", check, { passive: true });
    check();
  }

  /* ---------- smooth anchor ---------- */
  function initAnchors(root) {
    (root || document).querySelectorAll('a[data-uv-scroll]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var t = document.querySelector(a.getAttribute("href"));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }); }
      });
    });
  }

  function boot(root) {
    initReveal(root);
    initCounts(root);
    initProgress(root);
    initParallax(root);
    initSpotlight(root);
    initSticky(root);
    initGallery(root);
    initQty(root);
    initPdpSticky(root);
    initAnchors(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  /* Shopify theme editor: re-init when a section is added/reloaded */
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
